import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useApi } from "../../hooks/useApi";
import useMy from "../../hooks/useMy";
import { loginErrMsgString } from "../../pages/Login";
import Flex from "../DefaultStyles/Flex";
import Loader from "../DefaultStyles/Loader";
import { Input } from "../Input/Input";
import PwResettingModal from "../pages/Login/PwResettingModal";
import { DefaultModalCommonProps } from "../pages/Users/UserDetail/CommentModal/CommentModal";
import AlertModal from "./AlertModal";
import DefaultModalLayout from "./DefaultModalLayout";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";

interface ManagerPwInputModalProps extends DefaultModalCommonProps {
  confirmBtnText?: string;
}

export default function ManagerPwInputModal({
  closeEvent,
  confirmEvent,
  confirmBtnText,
}: ManagerPwInputModalProps) {
  const { email } = useMy();

  const [password, setPassWord] = useState("");

  const [checkPw, setCheckPw] = useState(false);
  const [exceedInputCountAlert, setExceedInputCountAlert] = useState(false);
  const [pwResettingModal, setPwResettingModal] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: checkPw ? `login` : undefined,
    data: {
      email: email ?? "",
      password: CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(password)),
      isSunset: 1,
    },
  });

  useEffect(() => {
    if (response?.data?.code === 200) {
      if (confirmEvent) {
        console.log(confirmEvent);

        confirmEvent();
      }
    } else if (response?.data?.code > 399) {
      setCheckPw(false);

      if (response?.data?.code === 403) {
        toast.error(
          loginErrMsgString(response?.data?.code, response?.data?.count) ??
            "로그인에 실패하였습니다."
        );
        setExceedInputCountAlert(true);
      } else if (response?.data?.code === 410) {
        toast.error(
          loginErrMsgString(response?.data?.code, response?.data?.count) ??
            "로그인에 실패하였습니다."
        );
        setPwResettingModal(true);
      } else {
        toast.error(
          loginErrMsgString(response?.data?.code, response?.data?.count) ??
            "로그인에 실패하였습니다."
        );
      }
    }
  }, [response]);

  useEffect(() => {
    console.log(error);
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle="관리자 비밀번호 입력"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => setCheckPw(true)}
      confirmBtnText={confirmBtnText ?? "확인"}
    >
      <>
        <Flex gapSize={40}>
          <ManagerPwInputModalLabel>비밀번호 입력</ManagerPwInputModalLabel>

          <Input
            type="password"
            value={password}
            onChange={(e) => setPassWord(e.target.value)}
            placeholder="입력"
          />
        </Flex>

        {/* 비밀번호 재설정 모달 */}
        {pwResettingModal && (
          <PwResettingModal
            closeEvent={() => setPwResettingModal(false)}
            email={email}
            originPw={password}
          />
        )}

        {/* 비밀번호 입력 횟수 초과, 임시 비밀번호 안내 모달  */}
        {exceedInputCountAlert && (
          <AlertModal
            btnColor="mint"
            title={
              "비밀번호 입력 횟수가 초과되어 이메일로 임시 비밀번호를 발급해 드렸어요.\n임시 비밀번호로 다시 로그인해 주세요."
            }
            customCancelBtn={<></>}
            confirmEvent={() => setExceedInputCountAlert(false)}
          />
        )}

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}

const ManagerPwInputModalLabel = styled.span`
  width: 30%;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: #858c97;
`;
